module.exports = __webpack_public_path__ + "img/icon-sort.934d07b7.svg";